import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFocusRemove"><Path d="M8.75 3H3V8.75H4.5V4.5H8.75V3Z" fill="currentColor"/><Path d="M21 3H15.25V4.5H19.5V8.75H21V3Z" fill="currentColor"/><Path d="M4.5 19.5V15.25H3V21H8.75V19.5H4.5Z" fill="currentColor"/><Path d="M21 21V15.25H19.5V19.5H15.25V21H21Z" fill="currentColor"/><Path d="M12 10.9393L9.7019 8.64124L8.64124 9.7019L10.9393 12L8.64124 14.2981L9.7019 15.3588L12 13.0607L14.2981 15.3587L15.3587 14.2981L13.0607 12L15.3588 9.7019L14.2981 8.64124L12 10.9393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusRemove;
